module.exports = "<div class=\"policyEngine\">\n     <policy-engine-menu></policy-engine-menu>\n     <ui-view ng-init=\"app.authorized.policyEngine.rulesManagement\"></ui-view>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/policyEngine/policyEngine.tpl.html
// module id = 1770
// module chunks = 0